<script setup lang="ts">
/**
 * AppLayout - основной layout авторизованной части.
 * Sidebar + Header + Main content.
 */
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import TheSidebar from './TheSidebar.vue'
import TheHeader from './TheHeader.vue'

const route = useRoute()
const sidebarCollapsed = ref(false)
const mobileMenuOpen = ref(false)

function toggleSidebar() {
  if (window.innerWidth < 1024) {
    mobileMenuOpen.value = !mobileMenuOpen.value
  } else {
    sidebarCollapsed.value = !sidebarCollapsed.value
  }
}
</script>

<template>
  <div class="flex h-screen overflow-hidden bg-base-100">
    <!-- Мобильный overlay -->
    <Transition name="fade">
      <div
        v-if="mobileMenuOpen"
        class="fixed inset-0 z-40 bg-black/50 lg:hidden"
        @click="mobileMenuOpen = false"
      />
    </Transition>

    <!-- Sidebar (desktop: static, mobile: drawer) -->
    <div
      class="fixed inset-y-0 left-0 z-50 lg:relative lg:z-auto transition-transform duration-300"
      :class="mobileMenuOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'"
    >
      <TheSidebar
        :collapsed="sidebarCollapsed"
        @toggle="toggleSidebar"
      />
    </div>

    <!-- Main content area -->
    <div class="flex-1 flex flex-col min-w-0 overflow-hidden">
      <TheHeader
        :title="(route.meta.title as string | undefined)"
        @toggle-sidebar="toggleSidebar"
      />

      <main class="flex-1 overflow-y-auto">
        <div class="container mx-auto p-4 sm:p-6 lg:p-8 max-w-6xl">
          <RouterView v-slot="{ Component }">
            <Transition
              name="page"
              mode="out-in"
            >
              <component :is="Component" />
            </Transition>
          </RouterView>
        </div>
      </main>
    </div>
  </div>
</template>

<style scoped>
.page-enter-active,
.page-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.page-enter-from {
  opacity: 0;
  transform: translateY(4px);
}
.page-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
